module.exports = __webpack_public_path__ + "static/yzwear-a813848e64fdae5043f6d9305995c00c.jpg";